import React from "react";
import NumberFormat from "react-number-format";
import "./Input.css";

class Input extends React.Component {
  renderControl(attributes, inputId) {
    const fieldClassName = `field-input-textarea ${attributes.errorClass ? "is-invalid" : ""} ${attributes.className || ""}`.trim();

    if (attributes.type === "textarea") {
      return (
        <textarea
          id={inputId}
          className={fieldClassName}
          name={attributes.name}
          disabled={attributes.disabled}
          required={attributes.required}
          value={attributes.value}
          onChange={attributes.onChange}
          onBlur={attributes.onBlur}
          rows={attributes.rows}
          placeholder={attributes.placeholder || ""}
          autoFocus={attributes.autoFocus}
        />
      );
    }

    if (attributes.type === "file") {
      const fileInput = (
        <input
          id={inputId}
          type="file"
          className={`form-control inputCustom file ${attributes.errorClass ? "is-invalid" : ""} ${attributes.className || ""}`.trim()}
          name={attributes.name}
          disabled={attributes.disabled}
          multiple={attributes.multiple}
          capture={attributes.capture}
          accept={attributes.accept}
          onChange={attributes.onChange}
        />
      );

      if (!attributes.native) return fileInput;

      return (
        <div className="divFileContainer">
          <div className="divButton">
            {attributes.placeholder || "Click here to select your files"}
          </div>
          {fileInput}
        </div>
      );
    }

    if (attributes.type === "number_format") {
      return (
        <NumberFormat
          id={inputId}
          className={fieldClassName}
          name={attributes.name}
          value={attributes.value}
          disabled={attributes.disabled}
          required={attributes.required}
          thousandSeparator
          prefix={attributes.prefix}
          format={attributes.format}
          placeholder={attributes.placeholder || ""}
          onBlur={attributes.onBlur}
          onValueChange={(values) => attributes.onChange?.(values.value)}
        />
      );
    }

    return (
      <input
        id={inputId}
        type={attributes.type || "text"}
        className={fieldClassName}
        name={attributes.name}
        disabled={attributes.disabled}
        required={attributes.required}
        value={attributes.value}
        min={attributes.min}
        max={attributes.max}
        maxLength={attributes.maxLength}
        autoComplete={attributes.autoComplete}
        onChange={attributes.onChange}
        onBlur={attributes.onBlur}
        ref={attributes.inputRef}
        placeholder={attributes.placeholder || ""}
        autoFocus={attributes.autoFocus}
      />
    );
  }

  render() {
    const attributes = this.props;
    const inputId = attributes.id || attributes.name;
    const label = attributes.label || attributes.placeholder;
    const isFile = attributes.type === "file";
    const showIcon = attributes.showSymbol && attributes.value;

    return (
      <div className="form-group input-container">
        {!isFile && !attributes.native && label && (
          <label htmlFor={inputId} className="field-label">
            {label}
          </label>
        )}

        <div className={attributes.symbolPosition === "right" ? "input-icon-right" : "input-icon"}>
          {showIcon && (
            attributes.faClass
              ? <i className={`fa ${attributes.faClass}`} />
              : <i><b>{attributes.symbol}</b></i>
          )}
          {this.renderControl(attributes, inputId)}
        </div>

        <div className={`invalid-feedback ${attributes.errorClass ? "is-invalid-show" : ""}`}>
          {attributes.errorMessage}
        </div>
      </div>
    );
  }
}

export default Input;
